import { useNavigate } from "react-router-dom";

import { Paths } from "@/core/constants/paths";
import type { NovaObraEntrada } from "@/screens/obras/rota-nova-obra";
import type { ObrasToolbarProps, ObrasToolbarViewModel } from "./types-obras-toolbar";

export function useObrasToolbar(props: ObrasToolbarProps): ObrasToolbarViewModel {
  const { isMobile } = props;
  const navigate = useNavigate();

  return {
    ...props,
    showStatusAndDate: !isMobile,
    controlSize: isMobile ? "small" : undefined,
    goToNova: () =>
      navigate(Paths.OBRAS_NOVA, { state: { daLista: true } satisfies NovaObraEntrada }),
  };
}
